import React, { useContext } from 'react'
import PropType from 'prop-types'
import cx from 'classnames'

import { fireGtmEvent } from 'utils/gtm'
import { getMetaQuery } from 'utils/data'
import useMaxCTALengthWarning from 'components/hooks/useMaxCTALengthWarning'
import WidgetContext from 'components/widget-context'
import { WSJ_THEME } from 'common/constants'
import getLayoutConfig from 'utils/getLayoutConfig'

import styles from './styles.module.scss'
import SimpleCTAComponent from './content/SimpleCTAComponent'
import simpleCtaConfig from './simpleCtaConfig'

const DEFAULT_VARIATIONS = {
  'compare-rates': 'Compare Rates',
  'find-my-rate': 'Find My Rate',
  'learn-more': 'Learn More',
}

const SimpleCta = ({
  url,
  variation,
  customCTA,
  utms,
  metaParams,
  verticals,
  type,
  theme = 'default',
  uniqueId,
  variations = DEFAULT_VARIATIONS,
  large = false,
  nmls = false,
  onClickHandle: customClickHandle = null,
}) => {
  const widgetContext = useContext(WidgetContext)
  const queryString = Object.keys(utms)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(utms[k])}`)
    .join('&')
  const metaQuery = getMetaQuery({ ...metaParams, marketplace: verticals, type }, theme)
  const href = `${url}?${queryString}${metaQuery}`
  const className = large ? styles.large : styles.small

  useMaxCTALengthWarning({ customCTA, large, uniqueId })

  const { AboveCta, BelowCta, Nmls } = getLayoutConfig(theme, simpleCtaConfig)
  const isWsjTheme = theme === WSJ_THEME

  const handleClick = () => {
    if (customClickHandle) {
      customClickHandle()
    } else {
      fireGtmEvent('ctaClick', widgetContext)
    }
  }

  return (
    <div className={cx(isWsjTheme ? styles.wsjContainer : styles.wrapper)}>
      <AboveCta />
      <SimpleCTAComponent
        href={href}
        className={className}
        customCTA={customCTA}
        onClick={handleClick}
        variations={variations}
        variation={variation}
      />
      <Nmls show={nmls} />
      <BelowCta />
    </div>
  )
}

SimpleCta.propTypes = {
  url: PropType.string.isRequired,
  variation: PropType.string.isRequired,
  uniqueId: PropType.string,
  customCTA: PropType.string,
  variations: PropType.object,
  utms: PropType.object.isRequired,
  large: PropType.bool,
  nmls: PropType.bool,
  onClickHandle: PropType.func,
  metaParams: PropType.object,
  verticals: PropType.oneOfType([PropType.array, PropType.string]),
  type: PropType.string,
  theme: PropType.string,
}

export default SimpleCta
